/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"
import { simulateContract } from "viem/actions"

import { clFarmGuardAbi } from "@/domains/abis"
import { simulatedTransaction } from "../simulated-transaction"

type RedeemClFarmLiquidityFromGuardProps = {
  chainId: number
  config: Config
  guardAddress: Address
  wrapperAddress: Address
  vdepAddress: Address
  amount: bigint
  account: Address
}

/**
 * Ichi uses a redeem from guard function.
 * @internal
 * @returns
 */
export const redeemClFarmLiquidityFromGuard = async ({
  chainId,
  config,
  guardAddress,
  wrapperAddress,
  vdepAddress,
  amount,
  account,
}: RedeemClFarmLiquidityFromGuardProps): Promise<TransactionReturnType> => {
  try {
    //#region Ichi requires some additional steps ..
    const client = config.getClient({ chainId })
    if (!client) throw new Error(`Failed to get client for chain ${chainId}`)

    if (!guardAddress || !wrapperAddress || !vdepAddress) {
      throw new Error("Missing required parameters")
    }

    const { result } = await simulateContract(client, {
      address: guardAddress,
      functionName: "forwardWithdrawFromICHIVault",
      abi: clFarmGuardAbi,
      // WRAP, VDEP, amount, user, minM, minO
      args: [wrapperAddress, vdepAddress, amount, account, BigInt(0), BigInt(0)],
      account,
    })
    //#endregion

    // modify the request with the minimum values BEFORE execution
    const min0 = (result[0] * BigInt(998)) / BigInt(1000)
    const min1 = (result[1] * BigInt(998)) / BigInt(1000)
    const args = [wrapperAddress, vdepAddress, amount, account, min0, min1]

    const finalTx = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: clFarmGuardAbi as Abi,
        account,
        address: guardAddress,
        args,
        chainId,
        functionName: "forwardWithdrawFromICHIVault",
      },
    })
    return finalTx
  } catch (error: any) {
    console.error("redeemClFarmLiquidityFromFarm", error)
    return { success: false, error: error.message, code: error.code }
  }
}
